module.exports = {"431321100":"永丰镇","431321101":"荷叶镇","431321102":"井字镇","431321103":"梓门桥镇","431321104":"杏子铺镇","431321105":"走马街镇","431321106":"蛇形山镇","431321107":"洪山殿镇","431321108":"甘棠镇","431321109":"三塘铺镇","431321110":"青树坪镇","431321111":"花门镇","431321112":"锁石镇","431321200":"石牛乡","431321201":"沙塘乡","431321202":"印塘乡","431321400":"经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431321.json
// module id = 1762
// module chunks = 0